import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Modal from "../Modal";
import SignIn from "./SignIn";

import { signIn, signInReset } from "@redux/signIn/actions";
import styles from "./index.module.scss";
import VerifyEmail from "../VerifyEmail";
import { verificationReset } from "@redux/verification/actions";

const SignInModal = () => {
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginStep, setLoginStep] = useState(true);

  const { isModalVisible } = useSelector(({ signInReducer }) => signInReducer);

  const closeModal = () => {
    dispatch(verificationReset());
    dispatch(signInReset());
    // setTimeout is used to prevent flickering
    setTimeout(() => {
      setEmail("");
      setPassword("");
      setLoginStep(true);
    }, 500);
  };

  const onBackClick = () => {
    setLoginStep(true);
  };

  const successCallback = () => {
    closeModal();
    if (!email || !password) return;
    dispatch(signIn({ email, password }));
  };

  return (
    <Modal
      centered
      unmountOnClose
      showCancel={false}
      showConfirm={false}
      onClose={closeModal}
      isOpen={isModalVisible}
      footerClassName="d-none"
      bodyClassName={styles.body}
    >
      <SignIn
        setEmail={setEmail}
        isVisible={loginStep}
        closeModal={closeModal}
        setPassword={setPassword}
        setLoginStep={setLoginStep}
      />
      <VerifyEmail
        email={email}
        isVisible={!loginStep}
        onBackClick={onBackClick}
        successCallback={successCallback}
      />
    </Modal>
  );
};

export default SignInModal;
